import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("開室予約の編集")
const _hoisted_2 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_3 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_4 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_5 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, "通知設定", -1)
const _hoisted_7 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", {
  for: "notification",
  class: "pl-2 cursor-pointer"
}, " 開室通知を送信 ", -1)
const _hoisted_9 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_10 = { class: "p-4 flex flex-col items-center rounded-md border-2 border-gray-200" }
const _hoisted_11 = {
  key: 0,
  class: "w-full flex items-center"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("p", null, "繰り返し終了日", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 予約削除 ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 変更を保存 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_m_select_box = _resolveComponent("m-select-box")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")
  const _component_m_base_modal = _resolveComponent("m-base-modal")

  return (_openBlock(), _createBlock(_component_m_base_modal, { onClose: _ctx.close }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_m_text_field, {
          label: "学習室名",
          name: "name",
          type: "text",
          placeholder: "学習室名を入力",
          value: _ctx.name,
          invalid: !_ctx.isValidName,
          "invalid-message": "学習室名は入力必須です",
          entered: "",
          class: "mb-6",
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.name = $event))
        }, null, 8, ["value", "invalid"])
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_m_select_box, {
          key: "ref.id",
          label: "対象グループ",
          name: "group",
          placeholder: "全て",
          options: _ctx.groups,
          value: _ctx.selectedGroupId,
          "value-key": "ref.id",
          "text-key": "data.title",
          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedGroupId = $event))
        }, null, 8, ["options", "value"])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_m_select_box, {
          key: "ref.id",
          label: "ラベル",
          name: "label",
          placeholder: "ラベルを選択",
          options: _ctx.labels,
          value: _ctx.selectedLabelId,
          "value-key": "ref.id",
          "text-key": "data.name",
          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedLabelId = $event))
        }, null, 8, ["options", "value"])
      ]),
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode("div", _hoisted_7, [
          _withDirectives(_createVNode("input", {
            id: "notification",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.withNotification = $event)),
            type: "checkbox",
            name: "notification",
            class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
          }, null, 512), [
            [_vModelCheckbox, _ctx.withNotification]
          ]),
          _hoisted_8
        ])
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          _createVNode(_component_m_text_field, {
            label: "開室予定日",
            name: "day",
            type: "date",
            placeholder: "2020/11/22",
            value: _ctx.reserveDay,
            invalid: !_ctx.isValidReserveDay,
            entered: "",
            class: "mb-6",
            onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.reserveDay = $event))
          }, null, 8, ["value", "invalid"]),
          _createVNode(_component_m_text_field, {
            label: "開室予定時間",
            name: "time",
            type: "time",
            placeholder: "18:00",
            value: _ctx.reserveTime,
            invalid: !_ctx.isValidReserveTime,
            entered: "",
            class: "mb-6",
            onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.reserveTime = $event))
          }, null, 8, ["value", "invalid"]),
          _createVNode(_component_m_text_field, {
            label: "閉室予定時間",
            name: "time",
            type: "time",
            placeholder: "",
            value: _ctx.endReserveTime,
            class: "mb-6",
            onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.endReserveTime = $event))
          }, null, 8, ["value"]),
          _createVNode(_component_m_select_box, {
            key: "id",
            label: "繰り返し設定",
            placeholder: "繰り返し頻度",
            name: "regular",
            options: _ctx.regularPatternOptions,
            value: _ctx.selectedRegularPattern,
            "value-key": "id",
            "text-key": "text",
            class: "mb-6",
            onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectedRegularPattern = $event))
          }, null, 8, ["options", "value"]),
          (_ctx.existDeletionTime)
            ? (_openBlock(), _createBlock("div", _hoisted_11, [
                _createVNode(_component_m_text_field, {
                  label: "繰り返し終了日",
                  name: "deletionDay",
                  type: "date",
                  placeholder: "2020/11/22",
                  value: _ctx.deletionDay,
                  class: "mb-6 flex-1",
                  onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.deletionDay = $event))
                }, null, 8, ["value"]),
                _createVNode(_component_m_button, {
                  color: "gray-500",
                  text: "",
                  size: "sm",
                  class: "ml-2 flex-0",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.existDeletionTime = false))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_m_icon, { type: "trash" })
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createBlock(_component_m_button, {
                key: 1,
                text: "",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.existDeletionTime = true))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_m_icon, {
                    type: "plus",
                    class: "mr-2"
                  }),
                  _hoisted_12
                ]),
                _: 1
              }))
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_m_button, {
        color: "red-400",
        "hover-color": "red-500",
        outline: "",
        class: "mr-4",
        onClick: _ctx.deleteRoomRegularlyReservation
      }, {
        default: _withCtx(() => [
          _hoisted_13
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_m_button, {
        color: "primary-500",
        "hover-color": "primary-600",
        disabled: !_ctx.isValidData,
        onClick: _ctx.updateRoomRegularlyReservation
      }, {
        default: _withCtx(() => [
          _hoisted_14
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["onClose"]))
}